import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { FirebaseStorageService } from '../../../services/firebase-storage.service';
import { Intervento } from '../../../models/intervento.model';
import { InterventiService } from '../../../services/interventi.service';
import { DeterminaInterventoRequest } from '../../../models/requests/determina-intervento.model';
import { AllegatoIntervento } from '../../../models/allegato-intervento.model';

@Component({
  selector: 'app-determina',
  templateUrl: './determina.component.html',
  styleUrls: ['./determina.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    FileUploadModule,
    ToastModule
  ],
  providers: [MessageService]
})
export class DeterminaComponent implements OnInit {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() intervento: Intervento | null = null;
  @Output() determinato = new EventEmitter<void>();

  numeroDetermina: string = '';
  note: string = '';
  fileDetermina: File[] | null = null;

  constructor(
    private messageService: MessageService,
    private logger: NGXLogger,
    private firebaseStorageService: FirebaseStorageService,
    private interventiService: InterventiService
  ) {}

  ngOnInit() {}

  show(intervento: Intervento) {
    this.intervento = intervento;
    this.visible = true;
    this.visibleChange.emit(this.visible);
    this.resetForm();
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
    this.intervento = null;
    this.resetForm();
  }

  resetForm() {
    this.numeroDetermina = '';
    this.note = '';
    this.fileDetermina = null;
  }

  isFormValid(): boolean {
    return this.numeroDetermina.trim() !== '' && this.fileDetermina !== null;
  }

  onFileSelect(event: any) {
    this.fileDetermina = event.files;
    this.logger.info('File selezionati', this.fileDetermina);
  }

  async salvaDetermina() {
    if (!this.isFormValid()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Compilare tutti i campi obbligatori',
        life: 3000
      });
      return;
    }

    try {
      let request: DeterminaInterventoRequest = {
        numeroDetermina: this.numeroDetermina,
        note: this.note,
        allegati: []
      };
      if (this.fileDetermina && this.intervento) {
        if (!this.intervento?.id) throw new Error('Intervento non valido');
        this.logger.info('Salvataggio determina', this.fileDetermina);
        for (const file of this.fileDetermina) {
          const path = `interventi/${this.intervento.id}/determina/${file.name}`;
          let allegato: AllegatoIntervento = {
            id: null,
            nomeFile: file.name,
            percorsoFile: path,
            tipoFile: file.type,
            dimensioneKb: file.size
          };
          request.allegati!.push(allegato);
          await this.firebaseStorageService.uploadFile(file, path).toPromise();
        }

       /*   this.interventiService.comunicaDetermina(this.intervento!, request).subscribe({
          next: () => {
            this.logger.info('Determina salvata con successo');
            this.determinato.emit();
            this.hide();
            this.reset();
          }
        }); */
      }
    } catch (error) {
      this.logger.error('Errore durante il salvataggio della determina', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Si è verificato un errore durante il salvataggio',
        life: 3000
      });
    }
  }

  reset() {
    this.numeroDetermina = '';
    this.note = '';
    this.fileDetermina = null;
  }
}
